import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

// login user
export async function loginUser({
    email,
    password
}) {
    const auth = getAuth();
    const account = await signInWithEmailAndPassword(auth, email, password);
    return account
}